import React, { Component } from 'react';
import { Loading } from "./Loading"

import { VotePageDecorativeElements } from "../../until925/components/VotePageDecorativeElements";
import {
    ShowNotStarted, NoVote, VotingPage, VotingSilencePage, VotingNumberPage
} from "../../until925/components/VotingPage";

import '../../until925/styles/Vote.css';

export class VoteWrapper extends Component {
    static displayName = "Vote";

    constructor(props) {
        super(props);

        this.state = {
            currentActiveShow: false,
            currentActivePoll: false,
            mostRecentPollID: 0,
            loading: true
        };
    }

    componentDidMount() {
        this.getPoll()
        this.timerId = setInterval(() => this.getPoll(), 2000); //2 Seconds
    }

    componentWillUnmount() {
        clearInterval(this.timerId)
    }

    async getPoll() {
        const response = await fetch('api/getPollInfo');
        const data = await response.json();
        this.setState({
            currentActiveShow: data["value"]["openShow"],
            currentActivePoll: data["value"]["openVote"],
            mostRecentPollID: data["value"]["recentPollId"],
            mostRecentVoteType: data["value"]["voteType"],
            loading: false
        });
    }

    render() {
        const loading = (this.state.loading);
        const activeShow = (this.state.currentActiveShow);
        const activePoll = (this.state.currentActivePoll);
        const recentPollID = (this.state.mostRecentPollID);
        const recentVoteType = (this.state.mostRecentVoteType);

        let voteComponent;
        if (loading) { voteComponent = <Loading /> }
        else if (!activeShow) { voteComponent = <ShowNotStarted /> }
        else if (!activePoll) { voteComponent = <NoVote /> }
        else if (recentVoteType === 3) { voteComponent = <VotingSilencePage activePollId={recentPollID} /> }
        else if (recentVoteType === 2) { voteComponent = <VotingNumberPage activePollId={recentPollID} /> }
        else { voteComponent = <VotingPage activePollId={recentPollID} /> }

        return (
            <div className="votePage page notShow">
                <VotePageDecorativeElements />
                {voteComponent}
            </div>
        );
    }
}